import { render, staticRenderFns } from "./handleYqjxps.vue?vue&type=template&id=bc7c4d78&scoped=true&"
import script from "./handleYqjxps.vue?vue&type=script&lang=js&"
export * from "./handleYqjxps.vue?vue&type=script&lang=js&"
import style0 from "./handleYqjxps.vue?vue&type=style&index=0&id=bc7c4d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7c4d78",
  null
  
)

export default component.exports